import React from "react";
import { Icon } from "@iconify/react";
import { HStack, VStack } from "../../../components/utils";

const STEPS = [
  {
    stepNo: 1,
    title: "Event Details",
    description: "Name, date, type, price and filters",
  },
  { stepNo: 2, title: "Preview", description: "Review affected grants" },
  {
    stepNo: 3,
    title: "Vesting Overrides",
    description: "Set per-tranche strike price overrides",
  },
  { stepNo: 4, title: "Approve", description: "Confirm and apply repricing" },
];

type Props = {
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
};

export default function OptionsRepricingStepper({
  currentStep,
  setCurrentStep,
}: Props) {
  return (
    <VStack className="pt-8 px-4 gap-0">
      {STEPS.map((step, index) => {
        const completed = currentStep > step.stepNo;
        const current = currentStep === step.stepNo;
        const isLast = index === STEPS.length - 1;

        return (
          <div key={step.stepNo}>
            <HStack
              className="cursor-pointer gap-3 py-3"
              onClick={() => {
                if (completed) setCurrentStep(step.stepNo);
              }}
            >
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-md shadow-md inline-flex justify-center items-center font-medium flex-shrink-0 ${
                    current
                      ? "bg-orange-501 text-white"
                      : completed
                      ? "bg-orange-100 text-orange-501"
                      : "bg-white text-gray-400 border border-gray-200"
                  }`}
                >
                  {completed ? (
                    <Icon icon="akar-icons:check" className="text-orange-501" />
                  ) : (
                    step.stepNo
                  )}
                </div>
                {!isLast && (
                  <div
                    className={`w-0.5 h-8 mt-1 ${
                      completed ? "bg-orange-300" : "bg-gray-200"
                    }`}
                  />
                )}
              </div>
              <VStack className="justify-start gap-0.5">
                <p
                  className={`text-sm font-medium ${
                    current ? "text-orange-501" : "text-black-501"
                  }`}
                >
                  {step.title}
                </p>
                <p className="text-xs text-gray-400">{step.description}</p>
              </VStack>
            </HStack>
          </div>
        );
      })}
    </VStack>
  );
}
